import gql from "graphql-tag";
import {quoteStringOrNull} from "../utils/quoteStringOrNull";

export default function query(params) {
        return gql`
            mutation {
                updateSaltoGateway(
                    id: "${params.id}"
                    type: ${params.type}
                    gwid: "${params.gwid}"
                    note: "${!params.note ? '' : params.note.replace(/(\r\n|\n|\r)/gm, "\\n")}"
                    name: ${quoteStringOrNull(params.name)}
                    tenant_id: ${quoteStringOrNull(params.tenant_id)}
                    product_type: ${params.product_type}
                ) {
                    errors
                    gateway {
                        id
                        device_id
                        garage_id
                        type
                        product_type
                        gwid
                        note
                        name
                        position{
                            lat
                            long
                        }
                        created_at
                        updated_at
                        deleted_at
                        garage_gateway {
                            name
                            id
                            state
                            echarger
                        }
                        health_status {
                            nfc_state
                            ble_state
                            rf_state
                            connection
                            main_controller_state
                        }
                    }
                }
            }`;
}
